import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import Font from '@maxpreps/shared/styles/font';
import React from 'react';
import Icon, { SportIcon } from '../../ui/Icon/Icon';
import { StyledPickerButton } from './StyledPickerModal';

interface IPickerButtonProps {
  onOpen?: (e: MouseEvent) => void;
  sport: string;
  text: string;
  href?: string;
}

const PickerButton: React.FC<IPickerButtonProps> = ({
  onOpen,
  sport,
  text,
  href
}) => {
  let linkProps: any = {};

  if (href)
    linkProps = {
      as: 'a',
      href,
      type: undefined
    };

  return (
    <StyledPickerButton
      onClick={onOpen}
      className={Font.f14_bold_tall}
      {...linkProps}
    >
      <SportIcon iconId={sport} size={16} $marginRight="6px" />
      {text}
      {/* @ts-ignore */}
      <Icon icon={faChevronUp} size={12} rotation={180} $marginLeft="4px" />
    </StyledPickerButton>
  );
};

export default PickerButton;
